import ConfigSelect from '@/views/ConfigSelect.vue';
import GameTesting from '@/views/GameTesting.vue';
import KSG from '@/views/KSG.vue';
import { createRouter, createWebHashHistory } from "vue-router";

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: "/",
      name: "Home",
      component: KSG,
    },
    {
      path: "/configselect",
      name: "ConfigSelect",
      component: ConfigSelect,
    },
    {
      path: "/gametesting",
      name: "GameTesting",
      component: GameTesting,
    },
    {
      path: "/ksg",
      name: "KSG",
      component: KSG,
    },
  ],
});

export default router;
